import type { ParentLinkSchema } from '@repo/schemas/parent/parentLink';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ParentKey } from './keys';
import { ParentService } from './parentService';

export function useLinkParent() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: ParentLinkSchema) => ParentService.linkParent(data).then((response) => response.data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [ParentKey.STUDENT_PARENTS, variables.studentId],
      });
      queryClient.invalidateQueries({
        queryKey: [ParentKey.PARENT_CHILDREN, variables.parentId],
      });
    },
  });
}
